import script from "./NavBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavBar.vue?vue&type=script&setup=true&lang=ts"

import "./NavBar.vue?vue&type=style&index=0&id=52e3bf49&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52e3bf49"]])

export default __exports__